import request from './axios';

/**
 * 获取招聘列表
 * @param {Object} params 查询参数
 * @param {Number} params.page 页码
 * @param {Number} params.pageSize 每页条数
 * @returns {Promise<Object>} 返回招聘列表和总数
 */
export function getRecruitList(params) {
  return request({
    url: '/webapi/recruits/list',
    method: 'get',
    params
  });
}

/**
 * 获取招聘详情
 * @param {String} id 招聘ID
 * @returns {Promise<Object>} 返回招聘详情
 */
export function getRecruitDetail(id) {
  return request({
    url: `/webapi/recruits/detail/${id}`,
    method: 'get'
  });
}

/**
 * 获取热门招聘
 * @returns {Promise<Object>} 返回热门招聘列表
 */
export function getHotRecruits() {
  return request({
    url: '/webapi/recruits/hot',
    method: 'get'
  });
}

/**
 * 获取岗位类型
 * @returns {Promise<Object>} 返回岗位类型列表
 */
export function getRecruitTypes() {
  return request({
    url: '/webapi/recruits/types',
    method: 'get'
  });
}

/**
 * 提交岗位申请
 * @param {FormData} formData 包含申请信息和简历文件的表单数据
 * @returns {Promise<Object>} 返回提交结果
 */
export function submitJobApplication(formData) {
  return request({
    url: '/webapi/job/apply',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
} 